import { createStyles, StylesClasses } from '@utils/styles'

const styles = createStyles({
  sectionWrapper: {
    pt: '-30px',
  },
  documentWrapper: {
    maxWidth: '898px',
  },
})

export type StylesClassNames = StylesClasses<typeof styles>

export default styles
